/** Default placeholder for an empty value. */
export const emptyDash = "\u2014";
